export const book_BOTTLE_NAMES = [
  "Aucune",
  "Bordeaux",
  "Alsace",
  "Bourgogne",
  "Champagne",
];
export declare type BookBottleName = typeof book_BOTTLE_NAMES[number];
